import './_styles.css';

import { EditarUsr } from '@newspacebpo/mf_nslogin';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as AuthActions from '../../../store/modules/auth/actions';

const defaultAvatar = require('../../../assets/img/avatars/usuario.jpg');

const DadosCadastrais = ({ auth, history, actions }) => {
  const goBack = () => {
    history.goBack();
  }

  const onUpdated = (userData) => {
    actions.update({
      ...userData,
      tokens: auth.user.tokens,
    });
    goBack();
  };

  return (
      <EditarUsr
        auth={auth}
        onUpdated={onUpdated}
        onBack={goBack}
        imageDefault={defaultAvatar}
      />
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AuthActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosCadastrais);
